import { render, staticRenderFns } from "./dailyReportListForCloth.vue?vue&type=template&id=06791b1c&scoped=true&lang=html&"
import script from "./dailyReportListForCloth.vue?vue&type=script&lang=js&"
export * from "./dailyReportListForCloth.vue?vue&type=script&lang=js&"
import style0 from "./dailyReportListForCloth.vue?vue&type=style&index=0&id=06791b1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06791b1c",
  null
  
)

export default component.exports